module.exports = __webpack_public_path__ + "2a4cbd9a66a0891099e0c2fd47946ff6.jpg";